import { VALID_NAME } from "../constants/regex";

export default (name) => VALID_NAME.test(name) && name.length > 2;
